import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './header.component';

@NgModule({
  declarations: [],
  imports: [HeaderComponent, RouterModule],
  exports: [HeaderComponent],
})
export class HeaderModule {}
